// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardSearch_wrapper__Mezef","input":"DashboardSearch_input__ITtZz","clearBtn":"DashboardSearch_clearBtn__3UMXh"};